<template>
  <!-- Begin Agogis.Widget.registerCourse -->
  <!-- Felder gemäss: C:\glit\gl it gmbh\Data - Dokumente\Kunden\Agogis\#Projects\agogis.ch\30 Umsetzung\20211006_ToccoFilterKriterienFuerWidgets.xlsx -->
  <!-- Mockup https://balsamiq.cloud/sdd5gk8/p69siy9/r44B7 -->
  <div class="form angebote anmeldung pWidget" :data-course-id="courseId">
    <div v-if="isLoading">
      <p-progress-linear indeterminate></p-progress-linear>
    </div>
    <div v-else-if="!course">
      <h3>{{ $t('widget.registerCourse.courseNotFound') }}</h3>
      <p-row>
        <p-col>
          <p-request-alert v-model="responseError"></p-request-alert>
        </p-col>
      </p-row>
    </div>
    <div v-else-if="responseError">
      <p-request-alert v-model="responseError"></p-request-alert>
    </div>
    <div v-else-if="isRegisterSuccess">
      <p-alert type="success" :value="true">
        {{ $t('widget.registerCourse.courseRegisterSuccess', course.name, $format.localDate(course.startDate)) }}
      </p-alert>
    </div>
    <p-form v-else no-summary :model="model" :schema="model.schema">
      <!-- <div>
        <p-card style="z-index: 100" width="400px" class="absolute-top-right ma-3">
          <p-code>
            {{ model.requestSummary.toDTO() }}
          </p-code>
        </p-card>
      </div> -->
      <p-container class="nameWrapper">
        <h1>{{ course.name }}</h1>
      </p-container>
      <p-container class="personalInfoWrapper">
        <h4>{{ $t('widget.registerCourse.sectionPersonalData') }}</h4>
        <p-row dense>
          <p-col xs12 class="salutation">
            <p-row>
              <p-radio-field v-model="model.contactAddress.salutation" :true-value="0" name="gender" :label="$tEnum('widget.registerCourse.genderEnum', 0)"></p-radio-field>
              <p-radio-field v-model="model.contactAddress.salutation" :true-value="1" name="gender" :label="$tEnum('widget.registerCourse.genderEnum', 1)"></p-radio-field>
            </p-row>
          </p-col>
          <p-col xs12 sm6 class="firstName">
            <p-text-field v-model="model.contactAddress.firstName" :label="$t('widget.registerCourse.firstName')"></p-text-field>
          </p-col>
          <p-col xs12 sm6 class="lastName">
            <p-text-field v-model="model.contactAddress.lastName" :label="$t('widget.registerCourse.lastName')"></p-text-field>
          </p-col>
          <p-col xs12 class="street">
            <p-text-field v-model="model.contactAddress.street" :label="$t('widget.registerCourse.street')"></p-text-field>
          </p-col>
          <p-col xs2 sm1 class="postalCode">
            <p-text-field v-model="model.contactAddress.postalCode" :label="$t('widget.registerCourse.postalCode')"></p-text-field>
          </p-col>
          <p-col xs10 sm11 class="city">
            <p-text-field v-model="model.contactAddress.city" :label="$t('widget.registerCourse.city')"></p-text-field>
          </p-col>
          <p-col xs6 class="dateOfBirth">
            <p-date-field v-model="model.contactAddress.dateOfBirth" :label="$t('widget.registerCourse.dateOfBirth')"></p-date-field>
          </p-col>
        </p-row>
      </p-container>
      <p-divider></p-divider>
      <p-container class="communicationWrapper">
        <p-row dense>
          <p-col xs12>
            <h4>{{ $t('widget.registerCourse.sectionCommunication') }}</h4>
          </p-col>
          <p-col xs12 sm6 class="mobilePhoneNumber">
            <p-phone-field v-model="model.contactAddress.mobilePhoneNumber" :label="$t('widget.registerCourse.mobilePrivate')"></p-phone-field>
          </p-col>
          <p-col xs12 sm6 class="phoneNumber">
            <p-phone-field v-model="model.contactAddress.phoneNumber" :label="$t('widget.registerCourse.phonePrivate')"></p-phone-field>
          </p-col>
          <p-col xs12 sm6 class="email">
            <p-text-field v-model="model.contactAddress.eMail" type="email" :label="$t('widget.registerCourse.eMail')"></p-text-field>
          </p-col>
          <p-col xs12 sm6 class="email repeat">
            <!-- none is an invalid value for autocomplete, but that actually prevents the autofill of the email -->
            <p-text-field v-model="model.contactAddress.eMailRepeat" autocomplete="none" type="email" :label="$t('widget.registerCourse.eMailRepeat')"></p-text-field>
          </p-col>
        </p-row>
        <p-row dense>
          <p-col xs12>
&nbsp;
          </p-col>
          <p-col xs12 sm6 class="correspondenceAddress">
            <p-col xs12>
              <h5>{{ $t('widget.registerCourse.sectionCorrespondenceAddress') }}</h5>
              <sup>&nbsp;</sup>
              <p-row dense class="isDifferent">
                <p-radio-field v-model="model.correspondenceAddress.isDifferent" :true-value="false" name="correspondence" :label="$t('widget.registerCourse.privateAddress')"></p-radio-field>
                <p-radio-field v-model="model.correspondenceAddress.isDifferent" :true-value="true" name="correspondence" :label="$t('widget.registerCourse.institutionAddress')"></p-radio-field>
              </p-row>
            </p-col>
          </p-col>
          <p-col v-if="course.price !== undefined" xs12 sm6 class="invoiceAddress">
            <p-col xs12>
              <h5>{{ $t('widget.registerCourse.sectionInvoiceAddress') }}</h5>
              <sup>{{ $t('widget.registerCourse.memberPriceInfo') }}</sup>
              <p-row dense class="isDifferent">
                <p-radio-field v-model="model.invoiceAddress.isDifferent" :true-value="false" name="invoice" :label="$t('widget.registerCourse.privateAddress')"></p-radio-field>
                <p-radio-field v-model="model.invoiceAddress.isDifferent" :true-value="true" name="invoice" :label="$t('widget.registerCourse.institutionAddress')"></p-radio-field>
              </p-row>
            </p-col>
          </p-col>
        </p-row>
      </p-container>
      <p-divider></p-divider>
      <template v-if="model.correspondenceAddress.isDifferent || model.invoiceAddress.isDifferent">
        <p-form :model="institutionModel" :schema="model.schemaInstitution">
          <p-container>
            <p-row dense class="institution">
              <p-col xs12 class="title">
                <h4>{{ $t('widget.registerCourse.sectionInstitution') }}</h4>
              </p-col>
              <p-col xs12 class="companyName">
                <p-text-field v-model="institutionModel.companyName" :label="$t('widget.registerCourse.companyName')"></p-text-field>
              </p-col>
              <p-col xs12 class="street">
                <p-text-field v-model="institutionModel.street" :label="$t('widget.registerCourse.street')"></p-text-field>
              </p-col>
              <p-col xs2 sm1 class="postalCode">
                <p-text-field v-model="institutionModel.postalCode" :label="$t('widget.registerCourse.postalCode')"></p-text-field>
              </p-col>
              <p-col xs10 sm11 class="city">
                <p-text-field v-model="institutionModel.city" :label="$t('widget.registerCourse.city')"></p-text-field>
              </p-col>
              <p-col xs12 sm6 class="phoneNumber">
                <p-phone-field v-model="institutionModel.phoneNumber" :label="$t('widget.registerCourse.phoneBusiness')"></p-phone-field>
              </p-col>
              <p-col xs12 sm6 class="eMail">
                <p-text-field v-model="institutionModel.eMail" :label="$t('widget.registerCourse.eMail')"></p-text-field>
              </p-col>
              <p-col xs12 sm6 class="subjectArea">
                <p-checkbox-group v-model="institutionModel.subjectArea" dense item-value="id" :items="model.subjectAreaList" :label="$t('widget.registerCourse.subjectArea')"></p-checkbox-group>
              </p-col>
            </p-row>
          </p-container>
        </p-form>
        <p-divider></p-divider>
      </template>
      <template v-if="specificQuestionsFormDefinition && specificQuestionsFormDefinition.fields.length > 0">
        <p-container class="questionsWrapper">
          <p-row dense class="specificquestions">
            <p-col xs12>
              <h4>{{ $t('widget.registerCourse.sectionSpecificQuestions') }}</h4>
            </p-col>
            <p-col xs12>
              <p-progress-linear v-if="!specificQuestionsFormDefinition" indeterminate></p-progress-linear>
              <p-dynamic-form
                v-model="model.registrationAnswers"
                :summary.sync="model.registrationAnswersSummary"
                :form-definition="specificQuestionsFormDefinition"
                no-contact-fields
                no-address-fields
              ></p-dynamic-form>
            </p-col>
          </p-row>
        </p-container>
        <p-divider></p-divider>
      </template>
      <template v-if="course.isWrittenExam">
        <p-container class="writtenExamWrapper">
          <p-row>
            <p-col xs12 class="title">
              <h4>{{ $t('widget.registerCourse.assessmentProfessionalSuitability.title') }}</h4>
            </p-col>
            <p-col xs12 class="download">
              <p-button
                class="download"
                @click="openAssessmentProfessionalSuitabilityTemplate()"
              >
                {{ $t('widget.registerCourse.assessmentProfessionalSuitability.templateDownload') }}
                <p-icon right>
                  download
                </p-icon>
              </p-button>
            </p-col>
            <p-col xs12 class="upload">
              <p-file-drop
                class="upload"
                :errors="assessmentProfessionalSuitabilityError"
                single
                :label="$t('widget.registerCourse.assessmentProfessionalSuitability.formUpload')"
                :messages="$t('control.maximumUploadFilesize')"
                :accept="$config.values['fileupload-documentextensions']"
                :capture="null"
                @input="onAssessmentProfessionalSuitabilityFilesInput($event)"
              ></p-file-drop>
            </p-col>
          </p-row>
        </p-container>

        <template v-if="course.isWrittenExamWithCompensation">
          <p-container class="limitationsWrapper">
            <p-row>
              <p-col xs12 class="title">
                <h4>{{ $t('widget.registerCourse.sectionCompensation') }}</h4>
              </p-col>
              <p-col class="limitationsWrapper">
                <div class="hasADHDWrapper">
                  <p-checkbox v-model="model.hasAdhd" :label="$t('widget.registerCourse.compensation.hasADHD')" :errors="compensationMissingError"></p-checkbox>
                  <div v-if="model.hasAdhd" class="detailWrapper">
                    <p-file-drop
                      :errors="adhdError"
                      single
                      :label="$t('widget.registerCourse.compensation.hasMedicalCertificate')"
                      :messages="$t('control.maximumUploadFilesize')"
                      :accept="$config.values['fileupload-documentextensions']"
                      :capture="null"
                      @input="onAdhdCertificateFilesInput($event)"
                    ></p-file-drop>
                  </div>
                </div>
                <div class="hasDyslexiaWrapper">
                  <p-checkbox v-model="model.hasDyslexia" :label="$t('widget.registerCourse.compensation.hasDyslexia')" :errors="compensationMissingError"></p-checkbox>
                  <div v-if="model.hasDyslexia" class="detailWrapper">
                    <p-file-drop
                      :errors="dyslexiaError"
                      single
                      :label="$t('widget.registerCourse.compensation.hasMedicalCertificate')"
                      :messages="$t('control.maximumUploadFilesize')"
                      :accept="$config.values['fileupload-documentextensions']"
                      :capture="null"
                      @input="onDyslexiaCertificateFilesInput($event)"
                    ></p-file-drop>
                  </div>
                </div>
                <div class="isForeignLanguageWrapper">
                  <p-checkbox v-model="model.isForeignLanguage" :messages="$t('widget.registerCourse.compensation.isForeignLanguageDetail')" :label="$t('widget.registerCourse.compensation.isForeignLanguage')" :errors="compensationMissingError"></p-checkbox>
                  <div v-if="model.isForeignLanguage" class="detailWrapper">
                    <p-select v-model="model.toccoNativeLanguageId" required :items="nativeLanguages" :label="$t('widget.registerCourse.compensation.foreignLanguage')"></p-select>
                    <p-text-field v-model="model.schoolEducationCountry" required :label="$t('widget.registerCourse.compensation.countryEducatedIn')"></p-text-field>
                  </div>
                </div>
                <div class="hasHearingImpairmentWrapper">
                  <p-checkbox v-model="model.hasHearingImpairment" :label="$t('widget.registerCourse.compensation.hasHearingImpairment')" :errors="compensationMissingError"></p-checkbox>
                  <div v-if="model.hasHearingImpairment" class="detailWrapper">
                    <p-file-drop
                      :errors="hearingImpairmentError"
                      single
                      :label="$t('widget.registerCourse.compensation.hasMedicalCertificate')"
                      :messages="$t('control.maximumUploadFilesize')"
                      :accept="$config.values['fileupload-documentextensions']"
                      :capture="null"
                      @input="onHearingImpairmentFilesInput($event)"
                    ></p-file-drop>
                  </div>
                </div>
                <div class="hasVisualImpairmentWrapper">
                  <p-checkbox v-model="model.hasVisualImpairment" :label="$t('widget.registerCourse.compensation.hasVisualImpairment')" :errors="compensationMissingError"></p-checkbox>
                  <div v-if="model.hasVisualImpairment" class="detailWrapper">
                    <p-file-drop
                      :errors="visualImpairmentError"
                      single
                      :label="$t('widget.registerCourse.compensation.hasMedicalCertificate')"
                      :messages="$t('control.maximumUploadFilesize')"
                      :accept="$config.values['fileupload-documentextensions']"
                      :capture="null"
                      @input="onVisualImpairmentFilesInput($event)"
                    ></p-file-drop>
                  </div>
                </div>
                <div class="hasOtherImpairmentWrapper">
                  <p-checkbox v-model="model.hasOtherDisabilities" :label="$t('widget.registerCourse.compensation.hasOtherImpairment')" :errors="compensationMissingError"></p-checkbox>
                  <div v-if="model.hasOtherDisabilities" class="detailWrapper">
                    <p-textarea v-model="model.otherDisabilitiesComment" required :label="$t('widget.registerCourse.compensation.otherImpairment')"></p-textarea>
                  </div>
                </div>
              </p-col>
            </p-row>
          </p-container>
          <p-divider></p-divider>
        </template>
      </template>
      <p-container class="additionalInformationWrapper">
        <p-row dense class="additionalInformation">
          <p-col xs12>
            <h4>{{ $t('widget.registerCourse.sectionAdditionalInformation') }}</h4>
          </p-col>
          <p-col xs12 class="comment">
            <p-textarea v-model="model.comment" :placeholder="$t('widget.registerCourse.comment')" :label="$t('widget.registerCourse.comment')"></p-textarea>
          </p-col>
          <template v-if="marketingQuestionsFormDefinition && marketingQuestionsFormDefinition.fields.length > 0">
            <p-col xs12>
              <p-progress-linear v-if="!marketingQuestionsFormDefinition" indeterminate></p-progress-linear>
              <p-dynamic-form
                v-model="model.marketingAnswers"
                :summary.sync="model.marketingAnswersSummary"
                :form-definition="marketingQuestionsFormDefinition"
                no-contact-fields
                no-address-fields
              ></p-dynamic-form>
            </p-col>
          </template>
        </p-row>
      </p-container>
      <p-divider></p-divider>
      <p-container class="newsletterWrapper">
        <p-row dense class="newsletter">
          <p-col xs12 class="accept">
            <p-checkbox v-model="model.acceptNewsletter" :label="$t('widget.registerCourse.acceptNewsletter')"></p-checkbox>
          </p-col>
        </p-row>
      </p-container>
      <p-divider></p-divider>
      <p-container class="gdprWrapper">
        <p-row dense class="gdpr">
          <p-col xs12 justify-end class="accept">
            <p-checkbox v-model="model.acceptGdpr" label="Slot">
              Ich habe die <a target="_blank" rel="noopener noreferrer" href="https://www.agogis.ch/agb">AGB</a> gelesen und akzeptiert
            </p-checkbox>
          </p-col>
          <p-col xs12 justify-end class="submit">
            <p-button :disabled="isSending" :loading="isSending" @click="sendForm">
              Anmelden
            </p-button>
          </p-col>
        </p-row>
      </p-container>
    </p-form>
  </div>
  <!-- End Agogis.Widget.registerCourse -->
</template>

<script lang="ts">
  import Vue from 'vue';
  import GetWidgetClassNativeLanguageLookupRequestViewModel from '../../../services/v1/viewModel/request/WidgetClasses/GetWidgetClassNativeLanguageLookupRequestViewModel';
  import Int32LookupResourceViewModel from '../../../services/v1/viewModel/resource/Int32LookupResourceViewModel';
  import DynamicFormDefinitionResourceViewModel from '../../../services/v1/viewModel/resource/DynamicFormDefinitionResourceViewModel';
  import ApiPagingRequestViewModel from '../../../services/v1/viewModel/resource/ApiPagingRequestViewModel';
  import ContactAddressResourceViewModel from '../../../services/v1/viewModel/resource/ContactAddressResourceViewModel';
  import RegisterClassRequestViewModel from '../../../services/v1/viewModel/resource/RegisterClassRequestViewModel';
  import WidgetClassListResourceViewModel from '../../../services/v1/viewModel/resource/WidgetClassListResourceViewModel';
  import WidgetSearchClassRequestViewModel from '../../../services/v1/viewModel/resource/WidgetSearchClassRequestViewModel';
  import WidgetUploadDocumentRequestViewModel from '../../../services/v1/viewModel/request/WidgetDocuments/WidgetUploadDocumentRequestViewModel';

  export default Vue.extend({
    layout: 'layout-widget-form',
    data: () => ({
      isRegisterSuccess: false,
      isSending: false,
      isLoading: true,
      specificQuestionsFormDefinition: undefined as DynamicFormDefinitionResourceViewModel | undefined,
      marketingQuestionsFormDefinition: undefined as DynamicFormDefinitionResourceViewModel | undefined,
      institutionModel: new ContactAddressResourceViewModel(),
      model: new RegisterClassRequestViewModel().fromDTO({
        contactAddress: {},
        correspondenceAddress: { contactAddress: {}, isDifferent: false },
        invoiceAddress: { contactAddress: {}, isDifferent: false },
        hasAdhd: false,
        hasDyslexia: false,
        hasVisualImpairment: false,
        hasHearingImpairment: false,
        hasOtherDisabilities: false,
        isForeignLanguage: false,
      } as any),
      courseId: -1,
      course: new WidgetClassListResourceViewModel(),
      nativeLanguages: [] as Int32LookupResourceViewModel[],
      responseError: undefined as any,
      assessmentProfessionalSuitabilityError: undefined as string | undefined,
      adhdError: undefined as string | undefined,
      dyslexiaError: undefined as string | undefined,
      visualImpairmentError: undefined as string | undefined,
      hearingImpairmentError: undefined as string | undefined,
      compensationMissingError: undefined as string | undefined,
    }),
    watch: {
      'model.correspondenceAddress.isDifferent': {
        handler() {
          if (!this.model.correspondenceAddress.isDifferent) {
            this.model.correspondenceAddress.contactAddress = new ContactAddressResourceViewModel();
          } else {
            this.updateFromInstitutionModel();
          }
        },
      },
      'model.invoiceAddress.isDifferent': {
        handler() {
          if (!this.model.invoiceAddress.isDifferent) {
            this.model.invoiceAddress.contactAddress = new ContactAddressResourceViewModel();
          } else {
            this.updateFromInstitutionModel();
          }
        },
      },
      'model.toccoNativeLanguageId': {
        handler() {
          this.model.nativeLanguage = this.nativeLanguages.find((e) => e.id === this.model.toccoNativeLanguageId)?.caption ?? undefined;
        },
      },
      'model.hasAdhd': {
        handler() {
          if (this.model.hasAdhd) this.compensationMissingError = undefined;
        },
      },
      'model.hasDyslexia': {
        handler() {
          if (this.model.hasDyslexia) this.compensationMissingError = undefined;
        },
      },
      'model.hasHearingImpairment': {
        handler() {
          if (this.model.hasHearingImpairment) this.compensationMissingError = undefined;
        },
      },
      'model.hasVisualImpairment': {
        handler() {
          if (this.model.hasVisualImpairment) this.compensationMissingError = undefined;
        },
      },
      'model.isForeignLanguage': {
        handler() {
          if (this.model.isForeignLanguage) this.compensationMissingError = undefined;
        },
      },
      'model.hasOtherDisabilities': {
        handler() {
          if (this.model.hasOtherDisabilities) this.compensationMissingError = undefined;
        },
      },
      institutionModel: {
        deep: true,
        handler() {
          this.updateFromInstitutionModel();
        },
      },
    },
    async mounted() {
      const pp = this.$routerUtils.getQueryParams();
      if (pp.id !== undefined) {
        this.courseId = Number.parseInt(pp.id, 10);
        if (!Number.isNaN(this.courseId)) {
          await this.loadCourseInformation();
          if (this.course?.isWrittenExamWithCompensation) {
            await this.getNativeLanguages();
          }
        } else {
          this.responseError = `Ungültige Kursnummer: ${pp.id}`;
        }
      } else {
        // TODO: Should this not be an error state, shown to the user?
        this.$log.error('No courseId given');
      }
      await this.getNativeLanguages();
    },
    methods: {
      updateFromInstitutionModel() {
        this.institutionModel.isCompany = true;
        if (this.model.correspondenceAddress.isDifferent) {
          this.model.correspondenceAddress.contactAddress = this.institutionModel;
          this.institutionModel.schema = this.model.schemaInstitution; // set schema when validation is needed
        }
        if (this.model.invoiceAddress.isDifferent) {
          this.model.invoiceAddress.contactAddress = this.institutionModel;
          this.institutionModel.schema = this.model.schemaInstitution; // set schema when validation is needed
        }
      },
      async sendForm() {
        if (this.model.correspondenceAddress.isDifferent || this.model.invoiceAddress.isDifferent) {
          // Needs to be validated separatly since it's not the same model, but schemas are kept in same place
          if (!this.institutionModel.validateWithSchema(this.model.schemaInstitution)) {
            // hotfix because of subjectArea is mandatory but not validated
            const ve = this.institutionModel.errors.find((e) => e.propName === 'subjectArea');
            if (ve !== undefined) {
              ve.message = `${Vue.$t('widget.registerCourse.subjectArea')}: ${ve.message}`;
            }
            return;
          }
        }
        if (!this.validate()) {
          return;
        }
        this.isSending = true;
        try {
          await this.$service.api.widgetClasses.widgetClassRegisterRequest(this.courseId, this.model);
          this.isRegisterSuccess = true;
        } catch (e: any) {
          this.responseError = e;
        }
        this.isSending = false;
      },
      validate() {
        const modelValidationRes = this.model.validate();
        let writtenExamValidationRes = true;
        let compensationValidationRes = true;
        if (this.course.isWrittenExam) {
          writtenExamValidationRes = this.validateWrittenExam();
          if (this.course.isWrittenExamWithCompensation) {
            compensationValidationRes = this.validateCompensation();
          }
        }
        return modelValidationRes && writtenExamValidationRes && compensationValidationRes;
      },
      validateWrittenExam() {
        let isValid = true;
        if (!this.model.assessmentProfessionalSuitabilityDocumentId) {
          this.assessmentProfessionalSuitabilityError = this.$t('core.validation.required');
          isValid = false;
        }
        return isValid;
      },
      validateCompensation() {
        let isValid = true;
        let isAtLeastOneCompensationSelected = false;
        if (this.model.hasAdhd) {
          isAtLeastOneCompensationSelected = true;
          if (!this.model.adhdCertificateDocumentId) {
            this.adhdError = this.$t('core.validation.required');
            isValid = false;
          }
        }
        if (this.model.hasDyslexia) {
          isAtLeastOneCompensationSelected = true;
          if (!this.model.dyslexiaCertificateDocumentId) {
            this.dyslexiaError = this.$t('core.validation.required');
            isValid = false;
          }
        }
        if (this.model.isForeignLanguage) {
          isAtLeastOneCompensationSelected = true;
        }
        if (this.model.hasHearingImpairment) {
          isAtLeastOneCompensationSelected = true;
          if (!this.model.hearingImpairmentCertificateDocumentId) {
            this.hearingImpairmentError = this.$t('core.validation.required');
            isValid = false;
          }
        }
        if (this.model.hasVisualImpairment) {
          isAtLeastOneCompensationSelected = true;
          if (!this.model.visualImpairmentCertificateDocumentId) {
            this.visualImpairmentError = this.$t('core.validation.required');
            isValid = false;
          }
        }
        if (this.model.hasOtherDisabilities) {
          isAtLeastOneCompensationSelected = true;
        }
        this.compensationMissingError = undefined;
        if (!isAtLeastOneCompensationSelected) {
          this.$nextTick(() => { this.compensationMissingError = this.$t('widget.registerCourse.sectionCompensationMissing'); });

          isValid = false;
        }
        return isValid;
      },
      async loadDynamicForms() {
        this.specificQuestionsFormDefinition = await this.$service.api.widgetClasses.getWidgetClassRegistrationQuestionsDefinition(this.courseId);
        this.marketingQuestionsFormDefinition = await this.$service.api.widgetClasses.getWidgetRegistrationMarketingQuestionsDefinition(this.courseId);
        const responseSubjectArea = await this.$service.api.widgetClasses.getWidgetSubjectAreas();
        this.model.subjectAreaList = responseSubjectArea.items;
      },
      async loadCourseInformation() {
        this.isLoading = true;
        await this.$guards.waitForAppLoad();
        try {
          const widgetSearchClassRequestVM = new WidgetSearchClassRequestViewModel();
          widgetSearchClassRequestVM.toccoFilter = `(pk == long:"${this.courseId}")`;
          const page = new ApiPagingRequestViewModel();
          page.pageSize = 1;
          widgetSearchClassRequestVM.paging = page;
          const response = await this.$service.v1.api.widgetClasses.getWidgetClasses(widgetSearchClassRequestVM);
          [this.course] = response.items.filter((i) => i.id === this.courseId);
          await this.loadDynamicForms();
          this.model.eventId = this.courseId;
        } catch (e : any) {
          this.responseError = e;
        }
        this.isLoading = false;
      },
      async uploadDocument(files: File[], errorSetter: (error: string | undefined) => void) {
        errorSetter(undefined);
        const [file] = (files ?? []);
        if (!file) {
          return undefined;
        }
        if (!this.isOfAllowedDocumentFileExtension(file)) {
          errorSetter(this.$t('widget.registerCourse.compensation.onlyDocumentsAndImagesAllowed'));
          return undefined;
        }
        const req = new WidgetUploadDocumentRequestViewModel();
        req.uploadFile = file;
        try {
          const document = await this.$service.v1.api.widgetClasses.widgetUploadDocument(this.courseId, req);
          return document;
        } catch (error: any) {
          this.$log.error(error);
          errorSetter(error?.detailMessage || error?.message);
          return undefined;
        }
      },
      isOfAllowedDocumentFileExtension(file: File): boolean {
        const allowedExtensions = Vue.$config.values['fileupload-documentextensions'];
        return allowedExtensions.some((ext) => file.name.endsWith(ext));
      },
      async onAssessmentProfessionalSuitabilityFilesInput(files: File[]) {
        const doc = await this.uploadDocument(files, (error) => { this.assessmentProfessionalSuitabilityError = error; });
        this.model.assessmentProfessionalSuitabilityDocumentId = doc;
      },
      async onAdhdCertificateFilesInput(files: File[]) {
        const doc = await this.uploadDocument(files, (error) => { this.adhdError = error; });
        this.model.adhdCertificateDocumentId = doc;
      },
      async onDyslexiaCertificateFilesInput(files: File[]) {
        const doc = await this.uploadDocument(files, (error) => { this.dyslexiaError = error; });
        this.model.dyslexiaCertificateDocumentId = doc;
      },
      async onHearingImpairmentFilesInput(files: File[]) {
        const doc = await this.uploadDocument(files, (error) => { this.hearingImpairmentError = error; });
        this.model.hearingImpairmentCertificateDocumentId = doc;
      },
      async onVisualImpairmentFilesInput(files: File[]) {
        const doc = await this.uploadDocument(files, (error) => { this.visualImpairmentError = error; });
        this.model.visualImpairmentCertificateDocumentId = doc;
      },
      async getNativeLanguages() {
        const req = new GetWidgetClassNativeLanguageLookupRequestViewModel();
        req.searchCriteria = '';
        req['paging.PageSize'] = 100;
        const res = await this.$service.v1.api.widgetClasses.getWidgetClassNativeLanguageLookup(req);
        this.nativeLanguages = res.items;
      },
      async openAssessmentProfessionalSuitabilityTemplate() {
        const url = Vue.$config.values['assessment-professional-suitability-download-url'];
        window.location.href = url;
      },
    },
  });
</script>
